<template>
  <div>
      <div class="ut-container-sm ut-pt-10">

        <p>
          Your current browser does not support this
          section of the OpenAgent agent tools.
        </p>
        <p>
          Please upgrade your browser or use another
          browser such as Mozilla Firefox or Google Chrome.
        </p>
        <p class="ut-inline-flex">
          You can find instructions to upgrade your current browser&nbsp;
          <a href="https://www.whatismybrowser.com/guides/how-to-update-your-browser/edge">here</a>.
        </p>


      </div>
  </div>
</template>

<script>

export default {
  name: 'IncompatibleBrowser',
  props: {
    ak: String,
  },
  created() {
    this.$helpers.gaPageView('/agentportal/incompatible-browser');
  },
  components: {
  },
  data() {
    return {
      isActive: false,
    };
  },
  computed: {
    gaLabel() {
      return `AID=${this.lam.agentid} | CurrentStage=${this.lam.stagetypeid} | CurrentState=${this.lam.statetypeid}`;
      // return `AID=${this.agent.id} | CurrentStage=${this.lam.stagetypeid} | CurrentState=${this.lam.statetypeid}`;
    },
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">

  a {
    @apply ut-block ut-underline ut-text-green-400;
  }

  p {
    @apply ut-py-3;
  }

</style>
